module.exports = __webpack_public_path__ + "img/reset_step1.a349a072.png";